import Vue from 'vue'
import Router from 'vue-router'
import qs from 'qs'

const routes = [
  { path: '/', component: () => import(`@/views/Frontpage.vue`) },
  // Public
  { path: '/trailers', component: () => import(`@/views/trailers/Trailers.vue`) },
  { path: '/trailers/:id', component: () => import(`@/views/trailers/Trailer.vue`) },
  // Booking
  { path: '/booking', component: () => import(`@/views/bookings/Booking.vue`) },
  { path: '/booking/details', component: () => import(`@/views/bookings/Details.vue`) },
  { path: '/booking/confirmation', component: () => import(`@/views/bookings/Confirmation.vue`) },
	// Pages
  { path: '/sharing', component: () => import(`@/views/pages/Sharing.vue`) },
  { path: '/about', component: () => import(`@/views/pages/About.vue`) },
  { path: '/compare', component: () => import(`@/views/pages/Compare.vue`) },
  { path: '/owner', component: () => import(`@/views/pages/Owner.vue`) },
  { path: '/owner/calculator', component: () => import(`@/views/pages/OwnerCalculator.vue`) },
  { path: '/owner/new', component: () => import(`@/views/pages/OwnerNew.vue`) },
  { path: '/thanks', component: () => import(`@/views/pages/Thanks.vue`) },
	// Landing
  { path: '/trailer-rental', component: () => import(`@/views/landing/TrailerRental.vue`) },
  { path: '/trailer-rental/curtain-trailer-rental', component: () => import(`@/views/landing/TrailerRentalCurtain.vue`) },
  { path: '/trailer-rental/reefer-trailer-rental', component: () => import(`@/views/landing/TrailerRentalReefer.vue`) },
  { path: '/trailer-rental/box-trailer-rental', component: () => import(`@/views/landing/TrailerRentalBox.vue`) },
  { path: '/trailer-rental/moving-floor-trailer-rental', component: () => import(`@/views/landing/TrailerRentalMovingFloor.vue`) },
  { path: '/trailer-rental/dolly-trailer-rental', component: () => import(`@/views/landing/TrailerRentalDolly.vue`) },
  { path: '/trailer-rental/flatbed-trailer-rental', component: () => import(`@/views/landing/TrailerRentalFlatbed.vue`) },
  { path: '/trailer-rental/container-chassis-trailer-rental', component: () => import(`@/views/landing/TrailerRentalContainerChassis.vue`) },
	// Notfound
  { path: '*',  component: () => import(`@/views/NotFound.vue`) },
]

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes,
  parseQuery: (query) => {
    return qs.parse(query);
  },
  stringifyQuery(query) {
    let result = qs.stringify(query, { encode: false });

    return result ? ('?' + result) : '';
  }
})

router.setPermissions = function (userPermissions) {
  this.userPermissions = userPermissions
}

router.beforeEach((to, from, next) => {
  const route = router.options.routes.find(r => r.path === to.path)
  const pathPermissions = route && route.meta && route.meta.permissions ? route.meta.permissions : []
  const userPermissions = router.userPermissions
  if (pathPermissions.length == 0) return next()
  if (!userPermissions) return next()
  if (userPermissions.some(el => pathPermissions.includes(el))) return next()
  next({ path: '/' })
})

// Make sure navbar collapses when changing route.
router.beforeEach((to, from, next) => {
  $('#navbarNav').collapse('hide')
  next()
})

// Make sure navbar collapses when changing route.
router.afterEach((to, from) => {
  window.Vue.$store.commit('app/refreshCurrentUrl', to.fullPath)
  window.scrollTo({top: 0})
})

export default router